<template>
  <div>
    <b-table
      v-if="!arrangeMode"
      id="table-transition-example"
      class="vgt-table bordered"
      :head-variant="headVariant"
      :items="listOfData"
      name="id"
      :fields="fields"
      responsive
      show-empty
      :tbody-transition-props="transProps"
      primary-key="id"
      :busy="loadingTable"
      @sort-changed="sortChanged"
      :no-sort-reset="true"
    >


      <!-- A virtual column -->
      <template #table-busy>
        <div class="text-center text-danger my-2">
          <b-spinner
            type="grow"
            label="Loading..."
            variant="primary"
          />
        </div>
      </template>

      <template
        v-for="(field,key) in fields"
        v-slot:[`cell(${field.key})`]="data"
      >
        <div :key="key">
            <!-- handle Image -->
          <b-avatar
            v-if="field.type=='image'"
            :src="$_.get(data.item, field.key) ? $_.get(data.item, field.key) : require('@/assets/images/user/default-user-image.png')"
            class="rounded-pill"
          />

            <div v-else-if="field.type == 'custom'">
                <slot :name="field.key" :data="data.item"></slot>
            </div>

          <!-- handle status -->
          <strong v-else-if="field.type == 'status'">
            <mainstatus :status="$_.get(data.item, field.key)" />
          </strong>

          <!-- actions -->
          <div v-else-if="field.type == 'actions'">
            <cell-actions
              :showActionInList="showActionInList"
              :cell-actions="field"
              :data-item="data.item"
            />
          </div>

          <!--   Promoting   -->
          <div v-else-if="field.type == 'promo'">
            <p class="m-0">
              <span v-if="$_.get(data.item, field.key) > 0">P ({{ $_.get(data.item, field.key) }})</span>
              <span v-else>NP</span>
            </p>
          </div>
          <!--    Offer      -->
          <div v-else-if="field.type == 'offer'">
            <p class="m-0" v-if="data.item.promotion_type === 'package'">{{ data.item.package }} for {{data.item.package_price_egp}} EGP</p>
            <p class="m-0" v-else-if="data.item.promotion_type === 'buy_x get_y'">Buy {{ data.item.buy_x }}, Get {{ data.item.get_y }}</p>
            <p class="m-0" v-else>{{ data.item.discount_price_egp }}%</p>
          </div>

          <!-- Array handler -->
          <div v-else-if="field.type == 'array'">
            <span v-if="field.array_keys" >
              <ul class="p-0">
                <li v-for="(arr, key) in $_.get(data.item, field.key).slice(0,4)" :key="key">
                  <span v-if="key==3">...</span>
                  <template v-else>
                    <span v-for="(ind, key1) in field.array_keys" :key="key1">{{ arr[ind] }} </span>
                  </template>
                </li>
              </ul>
            </span>
            <span v-else>
              <span v-for="(arr, key) in $_.get(data.item, field.key).slice(0,3)" :key="key">
                {{ arr }}
                <span v-if="(key < 3)">,</span>
              </span>
            </span>
          </div>

          <!-- Multi-image handler -->
          <div class="min-width-image-cell width-180px" v-else-if="field.type == 'multi_image'">
            <div class="iq-media-group position-relative">
              <b-link href="#" class="iq-media" v-for="(image, counter) in $_.get(data.item, field.key).slice(0,3)" :key="counter">
                <b-img class="avatar-40" rounded="circle" fluid :src="image.file" :alt="image.name" />
                <div v-if="($_.get(data.item, field.key).length > 3) && counter === 2" class="more-images text-white">{{ $_.get(data.item, field.key).length-3 }}+</div>
              </b-link>
            </div>
          </div>

          <!-- Multi-text handler -->
          <div v-else-if="field.type == 'multi-text'">
            <span v-for="(arrKey, key) in field.key.split(',')" :key="key">
              <span v-if="$_.get(data.item, arrKey)">
                {{ $_.get(data.item, arrKey) }}
              </span>
            </span>
          </div>

          <!-- rate -->
          <div v-else-if="field.type == 'rate'">
                {{ $_.get(data.item, arrKey) ? $_.get(data.item, arrKey) : 0 }}
          </div>

          <!-- Multi-currency handler -->
          <div v-else-if="field.type == 'multi-currency'">
            <ul class="p-0">
              <li v-for="(arrKey, key) in field.key.split(',')" :key="key">
                <span v-if="arrKey.includes('egp')">
                    <span v-if="$_.get(data.item, arrKey)">EGP {{ $_.get(data.item, arrKey) }}</span>
                    <span v-else>N/A</span>
                  </span>
                <span v-else-if="arrKey.includes('euro')">
                    <span v-if="$_.get(data.item, 'price_euro')">
                      <span v-if="arrKey.includes('discount')&& !$_.get(data.item, arrKey)">
                        N/A
                      </span>
                      <span v-else>€ {{ $_.get(data.item, arrKey) }}</span>
                    </span>
                  </span>
                <span v-else-if="arrKey.includes('dollar')">
                    <span v-if="$_.get(data.item, 'price_dollar')">
                      <span v-if="arrKey.includes('discount')&& !$_.get(data.item, arrKey)">
                        N/A
                      </span>
                      <span v-else>$ {{ $_.get(data.item, arrKey) }}</span>
                    </span>
                  </span>
              </li>
            </ul>
          </div>

          <!--    Calculate age      -->
          <div v-else-if="field.type == 'birthDate'">
            {{ calculateAge($_.get(data.item, field.key)) }}
          </div>

          <!--    Calculate validity      -->
          <div v-else-if="field.type == 'validity'">
            {{ dateDifference('', $_.get(data.item, field.key)) || '---' }}
          </div>

          <!-- handle Text -->
          <p
            v-else
            class="text-nowrap m-0"
          >
            <span v-if="$_.get(data.item, field.key)">
              {{ $_.get(data.item, field.key).length > limitOfChar ? $_.get(data.item, field.key).substring(0,limitOfChar) + '...' : $_.get(data.item, field.key) }}
            </span>
            <span v-else>
              ---
            </span>
          </p>
          
        </div>

      </template>

      <template v-slot:[`cell(#)`]="data">
        <div class="text-center">
          {{ pagination.from  + ( data.index ) }}
        </div>
      </template>

      <template v-slot:cell(change_status)="data">
        <changeStatus
            v-if="data.field.showIf ? data.field.showIf(): true"
            :allData = data
            :id="data.item.id"
            :type="data.field.tableType"
            :status="data.item.status"
            :statusKeyId="data.field.idKey"
            :post-key="data.field.postKey"
            @changeStatus="changeStatus"
        />
        <strong v-else>
          <mainstatus :status="data.item.status" />
        </strong>
      </template>
    </b-table>
    <div v-else class="table-responsive">
      <div v-if="loadingTable" class="text-center text-danger my-2">
        <b-spinner type="grow" label="Loading..." variant="primary" />
      </div>
      <div v-else>
        <table class="table vgt-table bordered mb-0">
          <thead>
            <tr>
              <th v-for="field in fields" :key="field.key" :class="field.class">
                {{ field.label }}
              </th>
            </tr>
          </thead>
          <draggable tag="tbody" :list="listOfData" handle=".drag-handle" ghost-class="dragging" @change="onDragChange">
            <tr v-for="(item, index) in listOfData" :key="item.id || index" :class="item._rowVariant">
              <td v-for="(field, key) in fields" :key="key" :class="field.class">
                <div>
                  <b-avatar
                    v-if="field.type=='image'"
                    :src="$_.get(item, field.key) ? $_.get(item, field.key) : require('@/assets/images/user/default-user-image.png')"
                    class="rounded-pill"
                  />

                  <div v-else-if="field.type == 'custom'">
                    <slot :name="field.key" :data="item"></slot>
                  </div>

                  <strong v-else-if="field.type == 'status'">
                    <mainstatus :status="$_.get(item, field.key)" />
                  </strong>

                  <div v-else-if="field.type == 'actions'">
                    <cell-actions
                      :showActionInList="showActionInList"
                      :cell-actions="field"
                      :data-item="item"
                    />
                  </div>

                  <div v-else-if="field.type == 'promo'">
                    <p class="m-0">
                      <span v-if="$_.get(item, field.key) > 0">P ({{ $_.get(item, field.key) }})</span>
                      <span v-else>NP</span>
                    </p>
                  </div>

                  <div v-else-if="field.type == 'offer'">
                    <p class="m-0" v-if="item.promotion_type === 'package'">{{ item.package }} for {{item.package_price_egp}} EGP</p>
                    <p class="m-0" v-else-if="item.promotion_type === 'buy_x get_y'">Buy {{ item.buy_x }}, Get {{ item.get_y }}</p>
                    <p class="m-0" v-else>{{ item.discount_price_egp }}%</p>
                  </div>

                  <div v-else-if="field.type == 'array'">
                    <span v-if="field.array_keys" >
                      <ul class="p-0">
                        <li v-for="(arr, arrayKey) in $_.get(item, field.key).slice(0,4)" :key="arrayKey">
                          <span v-if="arrayKey==3">...</span>
                          <template v-else>
                            <span v-for="(ind, k1) in field.array_keys" :key="k1">{{ arr[ind] }} </span>
                          </template>
                        </li>
                      </ul>
                    </span>
                    <span v-else>
                      <span v-for="(arr, arrayKey) in $_.get(item, field.key).slice(0,3)" :key="arrayKey">
                        {{ arr }}
                        <span v-if="(arrayKey < 3)">,</span>
                      </span>
                    </span>
                  </div>

                  <div class="min-width-image-cell width-180px" v-else-if="field.type == 'multi_image'">
                    <div class="iq-media-group position-relative">
                      <b-link href="#" class="iq-media" v-for="(image, counter) in $_.get(item, field.key).slice(0,3)" :key="counter">
                        <b-img class="avatar-40" rounded="circle" fluid :src="image.file" :alt="image.name" />
                        <div v-if="($_.get(item, field.key).length > 3) && counter === 2" class="more-images text-white">{{ $_.get(item, field.key).length-3 }}+</div>
                      </b-link>
                    </div>
                  </div>

                  <div v-else-if="field.type == 'multi-text'">
                    <span v-for="(arrKey, key2) in field.key.split(',')" :key="key2">
                      <span v-if="$_.get(item, arrKey)">
                        {{ $_.get(item, arrKey) }}
                      </span>
                    </span>
                  </div>

                  <div v-else-if="field.type == 'rate'">
                    {{ $_.get(item, field.key) ? $_.get(item, field.key) : 0 }}
                  </div>

                  <div v-else-if="field.type == 'multi-currency'">
                    <ul class="p-0">
                      <li v-for="(arrKey, key3) in field.key.split(',')" :key="key3">
                        <span v-if="arrKey.includes('egp')">
                          <span v-if="$_.get(item, arrKey)">EGP {{ $_.get(item, arrKey) }}</span>
                          <span v-else>N/A</span>
                        </span>
                        <span v-else-if="arrKey.includes('euro')">
                          <span v-if="$_.get(item, 'price_euro')">
                            <span v-if="arrKey.includes('discount')&& !$_.get(item, arrKey)">
                              N/A
                            </span>
                            <span v-else>€ {{ $_.get(item, arrKey) }}</span>
                          </span>
                        </span>
                        <span v-else-if="arrKey.includes('dollar')">
                          <span v-if="$_.get(item, 'price_dollar')">
                            <span v-if="arrKey.includes('discount')&& !$_.get(item, arrKey)">
                              N/A
                            </span>
                            <span v-else>$ {{ $_.get(item, arrKey) }}</span>
                          </span>
                        </span>
                      </li>
                    </ul>
                  </div>

                  <div v-else-if="field.type == 'birthDate'">
                    {{ calculateAge($_.get(item, field.key)) }}
                  </div>

                  <div v-else-if="field.type == 'validity'">
                    {{ dateDifference('', $_.get(item, field.key)) || '---' }}
                  </div>

                  <div v-else-if="field.type == 'sort'">
                    <span class="drag-handle mr-2" title="Drag to reorder">
                      <i class="las la-bars"></i>
                    </span>
                    <span>{{ index + 1 }}</span>
                  </div>

                  <p v-else class="text-nowrap m-0">
                    <span v-if="$_.get(item, field.key)">
                      {{ $_.get(item, field.key).length > limitOfChar ? $_.get(item, field.key).substring(0,limitOfChar) + '...' : $_.get(item, field.key) }}
                    </span>
                    <span v-else>---</span>
                  </p>
                </div>
              </td>
            </tr>
          </draggable>
          <tbody v-if="!listOfData.length">
            <tr>
              <td :colspan="fields.length" class="text-center py-4">No records found</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <b-pagination
      v-if="paginationFlag"
      v-model="pagination.current_page"
      :total-rows="pagination.total"
      :per-page="pagination.per_page"
      first-number
      last-number
      class="mb-3 mt-1 mt-sm-0"
      prev-class="prev-item"
      next-class="next-item"
      align="right"
      @input="getListData"
    >
    </b-pagination>
  </div>
</template>

<script>
import Bus from '@/eventBus'
import mainstatus from './status'
import mainService from '@/services/main'
import cellActions from './cellActions'
import changeStatus from './changeStatus'
import draggable from 'vuedraggable'
import { dateDifference } from '@/Helpers/helper'
import { core } from '@/config/pluginInit'
export default {
  components: {
    mainstatus,
    cellActions,
    changeStatus,
    draggable
  },
  props: {
    showActionInList: {
      type: Boolean,
      default: false
    },
    limitOfChar: {
      default: 20,
      required: false
    },
    fields: {
      type: Array,
      required: true
    },
    items: {
      type: [Array, Object],
      required: false
    },
    list_url: {
      type: String
    },
    additionalUrl: {
      type: String
    },
    params: {
      type: [Object, Array]
    },
    reloadData: {
      type: Boolean,
      default: false
    },
    paginationFlag: {
      type: Boolean,
      default: true
    },
    headVariant: {
      type: String,
      default: ''
    },
    arrangeMode: {
      type: Boolean,
      default: false
    },
    service_type: {
      type: String,
      default: ''
    },
    customFilter: {
      type: Object
    }
  },
  data () {
    return {
      transProps: {
        name: 'flip-list'
      },
      listOfData: [],
      total: 0,
      pagination: {
        current_page: 1,
        per_page: 10,
        total: 10,
        from: 1,
        to: 10
      },
      loadingTable: false,
      internalReload: false,
      moreImages: 2,
      autoCount: 1
    }
  },
  watch: {
    items: {
      handler(val) {
        if (Array.isArray(val) && val.length) {
          this.listOfData = val
          this.loadingTable = false
          this.dimInactive()
        } else if (Array.isArray(val) && this.loadingTable) {
          this.listOfData = []
          this.loadingTable = false
        }
      },
      immediate: true,
      deep: true
    },
    params () {
      this.getListData()
    },
    customFilter: {
      handler () {
        this.getListData()
      },
      deep: true
    },
    reloadData (val) {
      this.internalReload = val
    },
    internalReload (val) {
      if (val) {
        this.listOfData = []
        this.getListData()
      }
    }
  },
  created () {
    this.getListData()
  },
  methods: {
    dateDifference,
    async getListData () {
      this.listOfData = []
      this.total = 0
      let filters = {}
      if (this.params) {
        this.params.map(data => {
          filters[data.name] = data.checked
        })
      }
      this.loadingTable = true
      let List = []
      const page = this.paginationFlag ? `?page=${this.pagination.current_page}` : ''
      if (this.customFilter) {
        filters = this.customFilter
      }
      if (!Array.isArray(this.items)) {
        List = await
        mainService.listDataTabl(
          `${this.list_url}${page}${
            this.additionalUrl ? this.additionalUrl : ''}`,
          filters
        )
        if (List.data?.data?.data) {
          this.listOfData = List.data?.data?.data
          this.total = List.data?.data?.total
          this.pagination = {
            current_page: List.data?.data?.current_page,
            per_page: List.data?.data?.per_page,
            total: List.data?.data?.total,
            from: List.data?.data?.from,
            to: List.data?.data?.to
          }
        } else {
          this.listOfData = List.data?.data
        }
      } else {
        // items is caller-provided (even if empty) — trust it as-is, don't wait for another value
        this.listOfData = this.items
      }
      this.loadingTable = false
      this.internalReload = false
      this.dimInactive()
    },
    dimInactive () {
      this.listOfData.forEach(row => {
        row._rowVariant = row.status === 'inactive' ? 'secondary' : ''
      })
    },
    sortChanged (data) {
      this.$emit('sortChanged', data)
    },
    onDragChange (event) {
      if (!event.moved) {
        return
      }
      const movedItem = event.moved.element
      const newSort = event.moved.newIndex + 1
      if (!movedItem || !movedItem.id) {
        return
      }
      const payload = new URLSearchParams()
      payload.append('type', this.service_type || 'folder')
      payload.append('sort[]', movedItem.id)
      payload.append('sort[]', newSort)
      mainService.sort(payload).then(res => {
        core.showSnackbar('success', res.data.message)
        this.internalReload = true
      })
    },
    changeSort (id, type, sort) {
      mainService.sort({ id, type, sort }).then(res => {
        core.showSnackbar('success', res.data.message)
        this.internalReload = true
      })
    },
    changeStatus (data) {
      mainService.changeStatus(data.payload, data.postKey).then(res => {
        core.showSnackbar('success', res.data.message)
        const IndexRow = this.listOfData.findIndex(row => row.id === data.data.item.id)
        if (this.listOfData[IndexRow].status === 'active') {
          this.listOfData[IndexRow].status = 'inactive'
          this.listOfData[IndexRow]._rowVariant = 'secondary'
        } else if (this.listOfData[IndexRow].status === 'inactive') {
          this.listOfData[IndexRow].status = 'active'
          this.listOfData[IndexRow]._rowVariant = ''
        }
      })
    },
    calculateAge (date) {
      const today = new Date()
      const birthDate = new Date(date)
      let age = today.getFullYear() - birthDate.getFullYear()
      const m = today.getMonth() - birthDate.getMonth()
      if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
        age--
      }
      return age
    }
  },
  /* computed: {
    listOfData () {
      return this.items.map((item) => {
        this.item._rowVariant = item.status === 'active' ? 'secondary' : ''
      })
    }
  }, */
  mounted () {
    // Keep a reference so we can remove exactly this instance's handler on
    // destroy. Without the $off below, every mounted table leaves a live
    // listener behind — navigating between tables stacks up handlers, so a
    // single delete fires many duplicate getListData() requests that race and
    // leave the visible table showing stale data until a full page refresh.
    this._reloadAfterDelete = () => { this.internalReload = true }
    Bus.$on('reloadTableAfterDelete', this._reloadAfterDelete)
  },
  beforeDestroy () {
    Bus.$off('reloadTableAfterDelete', this._reloadAfterDelete)
  }
}
</script>
<style>
table#table-transition-example .flip-list-move {
  transition: transform 0.5s;
}
.sort-field {
  /*width: fit-content !important;*/
  width: 50px !important;
  border: none !important;
  border-bottom: 1px dashed grey !important;
}
.drag-handle {
  cursor: grab;
  display: inline-flex;
  align-items: center;
}
.dragging {
  background-color: rgba(0, 0, 0, 0.04);
}
#table-transition-example > thead > tr > th:nth-child(1) {
  text-align: center
}
</style>
